webshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		// Load-more (PIT-TASK-2027-000135): appended batches must extend the
		// list instead of replacing it.
		if (!this.append_mode) {
			this.products_section.empty();
		}

		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			// Image Only mood image (PIT-TASK-2027-000218): full-width image
			// row between the product rows — no link, no details.
			if (item.custom_image_only) {
				html += me.get_image_only_row_html(item);
				return;
			}

			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="row list-row w-100">`;
			html += me.get_image_html(item, title);
			html += me.get_item_details_section(item, title, me.settings);
			html += `</div>`;

		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.bind_qty_events();
	}

	bind_qty_events() {
		// Load-more (PIT-TASK-2027-000135): rebind safely with namespaced
		// delegated handlers on each append.
		this.products_section.off("input.wsQty click.wsQty");
		this.products_section.on("input.wsQty", ".item-qty-area .item-qty", (event) => {
			let currentValue = event.target.value;
			let validValue = currentValue.replace(/[^0-9]/g, "");
			event.target.value = validValue;
		});

		this.products_section.on("click.wsQty", ".item-qty-area .up-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(currentValue + step);
		});

		this.products_section.on("click.wsQty", ".item-qty-area .dwn-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let minQty = parseInt(item_qty.data("min-qty")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(Math.max(currentValue - step, minQty));
		});
	}

	get_image_html(item, title) {
		let image = item.website_image;
		const ratio_class = webshop.get_image_ratio_class ? webshop.get_image_ratio_class(this.settings) : "";
		const badge_html = webshop.get_new_badge_html ? webshop.get_new_badge_html(item) : "";
		const discount_badge_html = webshop.get_discount_badge_html ? webshop.get_discount_badge_html(item) : "";
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, this.settings) : `/${ item.route || '#' }`;

		if (image) {
			const img_html = `<img itemprop="image" class="card-img" src="${ image }" alt="${ title }"
					loading="lazy">`;
			return `
				<div class="col-3 list-image${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ img_html }</a>`
						: img_html }
				</div>
			`;
		} else {
			const no_image_html = `<div class="card-img-top no-image">${ frappe.get_abbr(title) }</div>`;
			return `
				<div class="col-3 list-image${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ no_image_html }</a>`
						: no_image_html }
				</div>
			`;
		}
	}

	get_image_only_row_html(item) {
		// Image Only mood image (PIT-TASK-2027-000218): full-width image
		// spanning the whole list row, without a link.
		const ratio_class = webshop.get_image_ratio_class ? webshop.get_image_ratio_class(this.settings) : "";
		// `ws-mood-image` = lightbox trigger (PIT-TASK-2027-000342); keyboard
		// reachable/openable like in the grid view.
		const img_html = item.website_image
			? `<img itemprop="image" class="card-img ws-mood-image" src="${ item.website_image }" alt="${ item.web_item_name || '' }" loading="lazy" role="button" tabindex="0" aria-label="${ __("Enlarge image") }">`
			: `<div class="card-img-top no-image">${ frappe.get_abbr(item.web_item_name || '') }</div>`;
		return `
			<div class="row list-row w-100 ws-image-only-card${ item.custom_fill_image ? ' ws-image-fill-card' : '' }">
				<div class="col-12 list-image${ ratio_class }">
					${ img_html }
				</div>
			</div>
		`;
	}

	get_item_details_section(item, title, settings) {
		let details = `
			<div class="col-9 text-left list-item-details">
				<div class="row">
					<div class="col-8">
		`;
		details += this.get_title_html(item, title, settings);
		details += this.get_item_details(item, settings);
		details += `
					</div>
					<div class="col-4 list-qty-col">
		`;
		// Wishlist icon (right column, below the qty controls)
		const wish_html = (!item.has_variants && settings.enable_wishlist)
			? this.get_wishlist_icon(item) : '';
		details += wish_html;
		details += `
					</div>
				</div>
		`;
		details += this.get_bottom_row_html(item, settings);
		details += `</div>`;
		return details;
	}

	// Short description + cart controls in one bottom row (PIT-TASK-2027-000141
	// adjustment): description on the left, qty + add-to-cart on the right,
	// pinned to the bottom of the row body (margin-top: auto via CSS).
	get_bottom_row_html(item, settings) {
		const cart_row = this.get_cart_action_row(item, settings);
		const desc = item.short_description
			? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;
		if (!desc && !cart_row) return ``;
		return `<div class="ws-bottom-row">${ desc }${ cart_row }</div>`;
	}

	get_title_html(item, title, settings) {
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, settings) : `/${ item.route || '#' }`;
		const title_html = item_link
			? `<a href="${ item_link }"
					style="color: var(--gray-800); font-weight: 600; text-decoration: none;">
					${ title }
				</a>`
			: `<span style="color: var(--gray-800); font-weight: 600;">${ title }</span>`;
		// Item's custom_additional_1 under the item name (PIT-TASK-2027-000308)
		const additional_1_html = webshop.get_custom_additional_1_html
			? webshop.get_custom_additional_1_html(item, settings) : "";
		return `
			<div style="display: flex; align-items: center;">
				<div style="flex: 1;">
					${ settings.custom_show_item_code ? `<div class="product-code-plain">${ item.item_code || '' }</div>` : '' }
					${ title_html }
					${ additional_1_html }
				</div>
			</div>
		`;
	}

	get_item_details(item, settings) {
		let details = '';
		if (settings.custom_show_item_group) {
			details += `
			<div class="product-category" itemprop="name">
				${ item.item_group_display || item.item_group }
			</div>
		`;
		}

		// Standard price display: the bulk list no longer contains the regular
		// price row (PIT-TASK-2027-000163 follow-up), so .product-price is the
		// single source of the Einzelpreis — render it whenever a price exists.
		// Sold Out (PIT-TASK-2027-000358 adjustment 1): not for flagged items.
		if (item.formatted_price && !item.custom_sold_out) {
			details += `
				<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
					${ item.formatted_price || '' }
			`;

			if (item.formatted_mrp) {
				details += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
			`;
			}

			details += this.get_stock_availability(item, settings);
			details += `</div>`;
		} else {
			details += this.get_stock_availability(item, settings);
		}

		return details;
	}

	get_stock_availability(item, settings) {
		// Sold Out toggle (PIT-TASK-2027-000358): an explicitly flagged
		// item is not for sale — the availability line says so and wins
		// over every stock/dispatcher hint below (the prices stay).
		if (item.custom_sold_out) {
			// Adjustment 2 (PIT-TASK-2027-000358): a sibling row renders its
			// status line INSIDE the .product-price block (see
			// get_item_details below), whose top margin the sold-out line has
			// to make up for — marker class set server-side (api.py).
			const reserve = item.ws_reserve_single_price ? ' ws-reserve-single-price' : '';
			return `
				<br>
				<span class="out-of-stock ws-sold-out mt-2${ reserve }" style="font-size: 14px;">${ __("Sold Out") }</span>
			`;
		}
		// "Sofort lieferbar" (PIT-TASK-2027-000280) on in-stock items —
		// mirrors the detail page's dispatcher line, independent of
		// show_stock_availability.
		if (!item.has_variants && item.is_stock && item.in_stock && !item.delivery_on_request) {
			return `
				<br>
				<span class="in-stock in-green has-stock mt-2"
					style="font-size: 14px;">${ __("Currently available") }</span>
			`;
		}
		// Next possible delivery date (PIT-TASK-2027-000324 adjustment 1):
		// dispatcher's earliest deliverable date for items that are NOT
		// currently in stock — same availability line in the list row as
		// "Currently available" / "Delivery date on request".
		if (
			!item.has_variants &&
			item.is_stock &&
			!item.in_stock &&
			!item.delivery_on_request &&
			item.next_delivery_date_formatted
		) {
			return `
				<br>
				<span class="next-delivery-date text-muted mt-2"
					style="font-size: 14px;">${ __("Earliest delivery date") }: ${ item.next_delivery_date_formatted }</span>
			`;
		}
		// "Liefertermin auf Anfrage" (PIT-TASK-2027-000324): same position as
		// "Currently available" in the list row — the availability line below
		// the title instead of the cart-action row.
		if (!item.has_variants && item.delivery_on_request) {
			return `
				<br>
				<span class="delivery-on-request text-muted mt-2"
					style="font-size: 14px;">${ __("Delivery date on request") }</span>
			`;
		}
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
				<br>
				<span class="out-of-stock mt-2" style="color: var(--primary-color)">
					${ __("Available on backorder") }
				</span>
			`;
			} else if (!item.in_stock) {
				return `
				<br>
				<span class="out-of-stock mt-2">${ __("Out of stock") }</span>
			`;
			}
		}
		return ``;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";

		return `

		<div class="like-action-list ${ item.wished ? "like-action-wished" : '' }" data-item-code="${ item.item_code }">
			<svg class="icon sm">
				<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
			</svg>
		</div>`;
	}

	get_cart_action_row(item, settings) {
		if (item.has_variants) {
			// Variants can only be chosen on the detail page — without it,
			// the Explore button has no target (PIT-TASK-2027-000166).
			if (webshop.detail_page_enabled && !webshop.detail_page_enabled(settings)) {
				return ``;
			}
			return `
				<div class="mt-3">
					<a href="/${ item.route || '#' }">
						<div class="btn btn-sm btn-explore-variants btn-cart-action">
							${ __("Explore") }
						</div>
					</a>
				</div>
			`;
		}

		// Card cart controls (PIT-TASK-2027-000379): when the Webshop Settings
		// toggle is on, the card renders no qty spinner and no add-to-cart
		// button at all (the cart row is omitted, not hidden via CSS).
		if (webshop.card_add_to_cart_hidden && webshop.card_add_to_cart_hidden(settings)) {
			return ``;
		}

		if (!settings.enabled) {
			return ``;
		}

		// Sold Out toggle (PIT-TASK-2027-000358): the item stays published
		// with its prices, but the cart controls are rendered disabled —
		// shopping_cart.js skips clicks on .ws-sold-out-btn and
		// cart.update_cart() rejects the item server-side.
		const sold_out = !!item.custom_sold_out;
		if (!sold_out && !settings.allow_items_not_in_stock && !item.in_stock) {
			return ``;
		}

		// "Liefertermin auf Anfrage" (PIT-TASK-2027-000344): no stock and no
		// open PO, but the item CAN be ordered — the dispatcher skips it at
		// order submit (custom_ignore_stock_dispatcher) instead of rejecting
		// the whole order. So the add-to-cart controls stay visible; the
		// availability line above still shows "Delivery date on request"
		// (PIT-TASK-2027-000324).

		return `
			<div class="cart-action-row mt-3">
				<div class="item-qty-area">
					<div class="input-group number-spinner">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn"${ sold_out ? " disabled" : "" }>
								&ndash;
							</button>
						</span>
						<input class="form-control text-center item-qty"
							value="${ item.min_qty || 1 }"
							min="${ item.min_qty || 1 }"
							step="${ item.lot_size || 1 }"
							data-item-code="${ item.item_code }"
							data-min-qty="${ item.min_qty || 1 }"
							data-lot-size="${ item.lot_size || 1 }"${ sold_out ? " disabled" : "" }>
						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up"${ sold_out ? " disabled" : "" }>
								+
							</button>
						</span>
					</div>
				</div>
				<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list${ sold_out ? " disabled ws-sold-out-btn" : "" }"
					data-item-code="${ item.item_code }"${ sold_out ? ' data-sold-out="1" aria-disabled="true"' : "" }
					title="${ sold_out ? __("Sold Out") : (settings.enable_checkout ? __("Add to Cart") : __("Add to Quote")) }">
					<svg class="icon icon-md" viewBox="0 0 24 24" fill="none">
						<path d="M3 6h17" stroke="currentColor" stroke-miterlimit="10"></path>
						<path d="M20 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6l3.4-3h10.2L20 6v13z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"></path>
						<path d="M15.582 10c0 2.29-1.8 4.09-4.091 4.09A4.051 4.051 0 0 1 7.4 10" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
						<circle cx="15.6" cy="10" r=".5" stroke="currentColor"></circle>
						<circle cx="7.3" cy="10" r=".5" stroke="currentColor"></circle>
					</svg>
					${ item.in_cart ? `<span class="ws-cart-count-badge" data-item-code="${ item.item_code }">${ item.in_cart_qty }</span>` : '' }
				</div>
			</div>
		`;
	}
};
